module.exports = __webpack_public_path__ + "static/media/head-sub.b6d7630d.svg";